import { Box } from '@mui/material';
import { useTheme } from '@mui/material';

import { Skeleton } from '@zendesk/forethought-elements';
import { CARD_HEIGHT, CARD_WIDTH } from './constants';

export default function LoadingCard() {
  const { palette } = useTheme();

  return (
    <Box
      border={`1px solid ${palette.colors.slate[200]}`}
      borderRadius='8px'
      height={CARD_HEIGHT}
      minWidth={CARD_WIDTH}
      p='24px'
    >
      <Skeleton height={24} variant='rounded' />
      <br />
      <Skeleton height={270} variant='rounded' />
    </Box>
  );
}
